export default __webpack_public_path__ + "static/media/irb.014b81bf.png";